export default "__VITE_ASSET__BDz3DRN9__"